"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaggeredAnimation = void 0;
var react_1 = __importDefault(require("react"));
var ReactCSSTransitionGroup = require("react-addons-css-transition-group");
var StaggeredAnimation = function (_a) {
    var children = _a.children, transitionTimeoutInMs = _a.transitionTimeoutInMs, delayInMs = _a.delayInMs, transitionName = _a.transitionName, disableLeaveAnimation = _a.disableLeaveAnimation;
    var numberOfChildren = react_1.default.Children.count(children);
    var transitionTimeoutFull = numberOfChildren * delayInMs + transitionTimeoutInMs;
    var decoratedChildren = react_1.default.Children.map(children, function (child, idx) {
        var delay = (idx + 1) * delayInMs;
        var delayFormatted = "".concat(delay, "ms");
        return react_1.default.cloneElement(child, { style: { animationDelay: delayFormatted } });
    });
    return (react_1.default.createElement(ReactCSSTransitionGroup, { component: react_1.default.Fragment, transitionName: transitionName, transitionAppear: true, transitionEnter: false, transitionAppearTimeout: transitionTimeoutFull, transitionLeaveTimeout: transitionTimeoutFull, transitionLeave: !disableLeaveAnimation }, decoratedChildren));
};
exports.StaggeredAnimation = StaggeredAnimation;
